import React, { createContext, useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import { useSelector } from "react-redux";
const SocketContext = createContext();

const SocketProvider = ({ socketUrl, children }) => {
  const token = useSelector((state) => state?.login?.data?.accessToken);

  const socketRef = useRef(null);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    socketRef.current = io(socketUrl, {
      transports: ["websocket"],
      auth: {
        token: token,
      },
    });
    setSocket(socketRef.current);

    return () => {
      socketRef.current.disconnect();
    };
  }, [socketUrl, token]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export { SocketContext, SocketProvider };
